import { useEffect, useState } from 'react'
import { ORDER_CANCEL_WINDOW_MS, type OrderStatus } from '../constants/orders'
import { canCancelOrder, isCancellableOrderStatus } from '../helpers/orders'

export function useCanCancelOrder(
  order: { status: OrderStatus; createdAt: string } | null,
): boolean {
  const [now, setNow] = useState(() => Date.now())
  const eligible = order ? isCancellableOrderStatus(order.status) : false
  const createdAt = order?.createdAt ?? ''

  useEffect(() => {
    if (!eligible) return
    const placedAt = Date.parse(createdAt)
    if (Number.isNaN(placedAt)) return
    const remaining = placedAt + ORDER_CANCEL_WINDOW_MS - Date.now()
    if (remaining <= 0) return
    const timer = window.setTimeout(() => setNow(Date.now()), remaining)
    return () => window.clearTimeout(timer)
  }, [createdAt, eligible])

  if (!order) return false
  return canCancelOrder(order, now)
}
